// alterado - revisado

import mapaFinanceiroItemList from '../../../business-rules/List/mapaFinanceiroItemList'

export const processaRegistrosDefaultIniciaisNotas = ( values ) => {

    if (!values.incluirMapaFinanceiroRelatorioCliente) {

        values.incluirMapaFinanceiroRelatorioCliente = false
    }

    if (!values.mapaFinanceiro) {

        values.mapaFinanceiro = []

        mapaFinanceiroItemList?.forEach( ( item, index ) => {
                
            values.mapaFinanceiro.push(
                {
                    id: item.id,
                    nota: null,
                }
            )
        })
    }
}